import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/exam-question-difficulty-levels/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const questionDifficultyLevels = {
  getAll: apiPathFunc(pathBase),
} as const;
